var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Trigger Ship")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-trigger-scope", {
                        attrs: { items: _vm.scopes, model: _vm.model.scope },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "scope", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Amount:", "hide-details": "" },
                        model: {
                          value: _vm.model.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "amount", _vm._n($$v))
                          },
                          expression: "model.amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-ship-kind", {
                        attrs: { model: _vm.model.trader, label: "Trader:" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "trader", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3", md: "3" } },
                    [
                      !!_vm.model.search
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "my-4 fill-width",
                              attrs: { small: "", color: "success" },
                              on: { click: _vm.onSearch },
                            },
                            [_vm._v("Search ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "my-4 fill-width",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: { click: _vm.onSearch },
                            },
                            [_vm._v("Search")]
                          ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3", md: "3" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-3",
                        attrs: { label: "Visible", "hide-details": "" },
                        model: {
                          value: _vm.model.visible,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "visible", $$v)
                          },
                          expression: "model.visible",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-search-dialog", { ref: "r-search-dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }